import { FunctionComponent } from 'react';
import classnames from 'classnames';

import { Props } from './index';
import StyledComponent from './styles';

const PublicPageJobSectionJobBlocksJobBenefits: FunctionComponent<Props> = ({
    headline,
    benefits,
    icon,
    iconAlt,
}) => {
    return (
        <StyledComponent
            className="public-page-company-site-section-company-block-benefits"
        >
            <div
                className="headline"
                dangerouslySetInnerHTML={{ __html: headline }}
            />
            <div
                className={classnames(
                    'list',
                    {
                        longList: benefits.length > 4,
                    }
                )}
            >
                {Array.isArray(benefits) && benefits.map(element => (
                    <div
                        key={element?.id}
                        className="list-element"
                    >
                        <img
                            className="icon"
                            src={icon}
                            loading="lazy"
                            alt={iconAlt}
                        />
                        <div
                            className="element-content"
                            dangerouslySetInnerHTML={{ __html: element?.name }}
                        />
                    </div>
                ))}
            </div>

        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobBenefits;